import apiClient from "./client";

export default {
  list: async () => {
    const res = await apiClient.get("/iot/subscriptions");
    return res.data;
  },
  get: async (id) => {
    const res = await apiClient.get(`/iot/subscriptions/${id}`);
    return res.data;
  },
  create: (payload) => apiClient.post("/iot/subscriptions", payload),
  update: (id, payload) => apiClient.put(`/iot/subscriptions/${id}`, payload),
  remove: (id) => apiClient.delete(`/iot/subscriptions/${id}`),
};
